const currentYear = new Date().getFullYear();
const INITIAL_STATE = {
  currentYear: currentYear,
  type: 2,
  bumd: "",
  jenis: "",
  periode: "",
  kinerja: "",
  startMonth: 0,
  endMonth: 0,
  startYear: currentYear - 5,
  endYear: currentYear,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "change_var_filter":
      return { ...state, [action.payload.prop]: action.payload.value };
    default:
      return state;
  }
};
